import { ApiStatus } from "common/enums";
import { UserState } from "../../models";
import { UserLoginStatus } from "common/enums/api-status.enum";

const initialUserState: UserState = {
  id: "",
  displayName: "",
  givenName: "",
  surname: "",
  userPrincipalName: "",
  mail: "",
  avatar: "",
  userRole: [],
  accessStatus: ApiStatus.NONE,
  profileApiStatus: ApiStatus.NONE,
  avatarApiStatus: ApiStatus.NONE,
  loginStatus: UserLoginStatus.LOGIN_PROGRESS,
  isTokenBlacklisted: false
};

export default initialUserState;
